import { gql } from '~/techstyle-shared/react-graphql';

// Reference: https://studio.apollographql.com/graph/fashionos/variant/dev/schema/reference/objects/Query?query=productpricing
// Previous version: {BASE_PRODUCTS_PRICING_QUERY_PRICING_SERVICE} from '~/techstyle-shared/react-graphql/queries/products';

/**
 * According to Matt McCabe from the API team,
 * this particular endpoint treats code 3930 and 3925 as vip,
 * all other codes are treated as lead, see full doc of the codes:
 * https://confluence.techstyle.net/display/API/Status+Codes.+ALL+OF+THEM
 * */
export const MEMBERSHIP_STATUS = {
  VIP: 3930,
  PROSPECTIVE: 3926,
};

// TODO: remove unnecessary fields
export const PRICING_QUERY_PRICING_SERVICE = gql`
  fragment PricingFields on CustomerProductPrice {
    final
    finalDetails {
      displayOnPdp
      promoCode
      promoLabel
      promoPrice
      promoTypeId
    }
    masterProductId
    sales
    vip
    retail
    outlet
    pricingDatasource {
      sourceUrl
      version
    }
  }

  query CioBrowseGridPricingService(
    $masterProductIds: [Int]
    $membershipStatus: Int
  ) {
    productPricing(
      masterProductIds: $masterProductIds
      membershipStatus: $membershipStatus
    ) {
      ...PricingFields
    }
  }
`;

/**
 *
 * Function to fetch Pricing Service data using GraphQL via Apollo client.
 *
 * @param {Object} apolloClient - Apollo client instance
 * @param {Array} masterProductIds - Array of master product IDs
 * @param {boolean} isVip - Flag to indicate if the user is a VIP member
 * @returns {Promise} - Promise that resolves to the pricing data
 */
const getGqlPricingDataPricingService = ({
  apolloClient,
  masterProductIds,
  isVip,
}) => {
  const productPricingVariables = {
    masterProductIds: masterProductIds.map((id) => Number(id)),
    membershipStatus: isVip
      ? MEMBERSHIP_STATUS.VIP
      : MEMBERSHIP_STATUS.PROSPECTIVE,
  };

  return apolloClient.query({
    context: {
      clientName: 'supergraph',
      headers: {
        'x-datasource-version': 'pricingService',
      },
    },
    query: PRICING_QUERY_PRICING_SERVICE,
    variables: productPricingVariables,
    errorPolicy: 'all',
  });
};

export default getGqlPricingDataPricingService;
